import React, { useState, useContext } from 'react';
import { UserContext } from '../../../lib/usercontext';
import { useLocation, useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import GeneralButton from '../button_general';
import ClientModal from '../modals/client_modal';

function OrderFilterComponent({ onFilterChange }) {
  const { user } = useContext(UserContext);
  const role = user.userGroups ? user.userGroups[0] : 'Customer';
  const isAdmin = role === 'Admin'; 

  const navigate = useNavigate();
  const location = useLocation();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateSet, setDateSet] = useState('');
  const [deliveryStatus, setDeliveryStatus] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);

  const handleFilterApply = () => {
    const params = new URLSearchParams(location.search);

    if (startDate) {
      params.set('after_date', startDate.toISOString().split('T')[0]);
    } else {
      params.delete('after_date');
    }

    if (endDate) {
      params.set('before_date', endDate.toISOString().split('T')[0]);
    } else {
      params.delete('before_date');
    }

    if (dateSet) {
      params.set('date_set', dateSet);
    } else {
      params.delete('date_set');
    }

    if (deliveryStatus) {
      params.set('delivery_status', deliveryStatus);
    } else {
      params.delete('delivery_status');
    }

    if (selectedClient) {
      params.set('client_id', selectedClient.client_id);
    } else {
      params.delete('client_id');
    }

    navigate({ search: params.toString() });
    onFilterChange(selectedClient);
  };

  const handleFilterClear = () => {
    setStartDate(null);
    setEndDate(null);
    setDateSet('');
    setDeliveryStatus('');
    setSelectedClient(null);

    const params = new URLSearchParams(location.search);
    params.delete('after_date');
    params.delete('before_date');
    params.delete('date_set');
    params.delete('delivery_status');
    params.delete('client_id');

    navigate({ search: params.toString() });
    onFilterChange(null);
  };

  return (
    <div className="filter-component flex flex-wrap items-end space-x-4 mb-0 ml-2">
      <div className="flex flex-col mb-4">
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="start_date">Delivery Start Date</label>
        <DatePicker
          id="start_date"
          selected={startDate}
          onChange={date => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          dateFormat="yyyy-MM-dd"
          className="p-2 border border-gray-300 rounded bg-gray-50 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        />
      </div>
      <div className="flex flex-col mb-4">
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="end_date">Delivery End Date</label>
        <DatePicker
          id="end_date"
          selected={endDate}
          onChange={date => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          dateFormat="yyyy-MM-dd"
          className="p-2 border border-gray-300 rounded bg-gray-50 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        />
      </div>
      <div className="flex flex-col mb-4">
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="date_set">Date Set?</label>
        <select
          id="date_set"
          value={dateSet}
          onChange={(e) => setDateSet(e.target.value)}
          className="p-2 border border-gray-300 rounded bg-gray-50 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 min-w-[150px]"
        >
          <option value="">Select</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>
      <div className="flex flex-col mb-4">
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="delivery_status">Delivery Status</label>
        <select
          id="delivery_status"
          value={deliveryStatus}
          onChange={(e) => setDeliveryStatus(e.target.value)}
          className="p-2 border border-gray-300 rounded bg-gray-50 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 min-w-[150px]"
        >
          <option value="">Select</option>
          <option value="scheduled">Scheduled</option>
          <option value="delivered">Delivered</option>
          <option value="canceled">Canceled</option>
        </select>
      </div>
      <div className="flex flex-col">
      {isAdmin && (<ClientModal
          isOpen={isClientModalOpen}
          setIsOpen={setIsClientModalOpen}
          selectClient={setSelectedClient}
          value={selectedClient}
          isSelectable={true}
          useButton={false}
        />) }
      </div>
      <div className="flex flex-col mb-4">
        <GeneralButton type="button" buttonType="primary" onClick={() => handleFilterApply()}>
          Apply Filters
        </GeneralButton>
      </div>
      <div className="flex flex-col mb-4">
        <GeneralButton type="button" buttonType="secondary" onClick={() => handleFilterClear()}>
          Clear Filters
        </GeneralButton>
      </div>
    </div>
  );
}

export default OrderFilterComponent;
